import { api, apiMipe } from '@/core/api/';
import service from '@/modules/app/api';

const deticketsBaseURL = 'api/supportticket';

export const getUserCases = (params, pageIndex, pageSize) =>
  api.get(`${deticketsBaseURL}/search`, {
    params: { ...params, pageIndex, pageSize },
  });

export const getUserCaseStatus = () => api.get(`${deticketsBaseURL}/status`);

export const deleteCase = (itemId) =>
  api.delete(`${deticketsBaseURL}/case`, {
    params: {
      itemId,
    },
  });

export const getUserCaseModules = (params) =>
  api.get(`${deticketsBaseURL}/modules`, { params });

export const getUserCaseScreens = (moduleId) =>
  api.get(`${deticketsBaseURL}/screens/${moduleId}`);

export const getUserCaseReferenceNumberTypes = (params) =>
  api.get(`${deticketsBaseURL}/referencenumbertypes`, { params: params });

export const getUserCaseById = (itemId) =>
  api.get(`${deticketsBaseURL}/case/${itemId}`);

export const saveUserCase = (formData) =>
  api.post(`${deticketsBaseURL}/create`, formData);

export const downloadDocument = async (documentId) => {
  api.get(`${deticketsBaseURL}/download/${documentId}`).then((res) => {
    const document = res.data;
    service.documentDownloadReport(document.content, document.filename);
  });
};

export const saveCommentManagement = (formData) =>
  api.post(`${deticketsBaseURL}/savecommentmanagement`, formData);

export const saveAdditionalInfo = (formData) =>
  api.post(`${deticketsBaseURL}/saveadditionalinformation`, formData);

export const getCommentHistory = (caseNumber) =>
  api.get(`${deticketsBaseURL}/commentshistory`, {
    params: { caseNumber },
  });

export const getPreviousContactInformation = () =>
  apiMipe.get(`${deticketsBaseURL}/previouscontactinformation`);

export const validateReferenceNumber = (reference, referenceType) =>
  api.get(
    `${deticketsBaseURL}/validatereferencenumber?reference=${reference}&referenceType=${referenceType}`
  );

export const getCaseModules = () =>
  api.get(`${deticketsBaseURL}/modules/providers`);

export const getTicketCatalogues = (itemSubTypeId) => {
  return api.get(`${deticketsBaseURL}/ticketcatalogues/${itemSubTypeId}`);
};

export const getItemSubTypes = () => {
  return api.get(`${deticketsBaseURL}/itemsubtypes`);
};
